const url = "/cronogramas";
const id = "idenCronograma";

export function buscarCronogramasPorParametroExercicio(idenParametroExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`${url}/fase/permissao/${idenParametroExercicio}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarCronogramaPorParametroExercicioAtivoResumido(idenParametroExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`${url}/data/${idenParametroExercicio}`).then((res) => {
      resolve(res);
    });
  });
}
